<template>
  <Header headerShadow="header__area header__padding header__padding-2 header__shadow " />
  <Breadcrumb title="Fale Conosco" />
  <ContactArea/>
  <Footer footerPadding="true" />
</template>

<script>
import Header from '../components/Home/Header';
import Footer from '../components/Home/Footer.vue';
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import ContactArea from "@/components/Contact/ContactArea.vue";

export default {
  name:'ContatoPage',
  components:{
    ContactArea,
    Breadcrumb,
    Header,
    Footer,
  }
}
</script>

